import { SizeType } from 'antd/lib/config-provider/SizeContext';
import styled from 'styled-components';

import { inputSizeStyleNorlys } from '~src/branding';
import { BodilFont } from '~src/branding/font';
import { useDisplayContext } from '~src/context/DisplayContext';

export const AntInputWrapper = styled.div<{ size: SizeType }>(({ size }) => {
  const { isMobile } = useDisplayContext();

  const { height, width } = inputSizeStyleNorlys(size);
  const fontStyle = BodilFont.style('default', size === 'large' ? 16 : 14);

  return {
    position: 'relative',
    width: isMobile ? '100%' : width,
    maxWidth: '100%',
    fontSize: size === 'large' ? '16px' : '14px',
    '.ant-input': {
      paddingLeft: '8px',
      borderRadius: '4px',
      ...fontStyle,
    },
    '.ant-input-number-input': {
      paddingLeft: '8px',
      borderRadius: '4px',
      ...fontStyle,
    },
    '.ant-select-single:not(.ant-select-customize-input) .ant-select-selector': {
      height,
      borderWidth: '2px',
      ...fontStyle,
      borderRadius: '4px',
    },
    '.ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input': {
      position: 'absolute',
      top: '35%',
      width: '85%',
    },
    '.ant-select-single .ant-select-selector .ant-select-selection-item': {
      position: 'absolute',
      top: '35%',
    },
    '.ant-select-selection-placeholder': {
      position: 'absolute',
      top: '35%',
    },
    '.ant-input:placeholder-shown': {
      paddingLeft: '8px',
    },
    '.ant-input-number-input:placeholder-shown': {
      paddingLeft: '8px',
    },
  };
});
